import React from 'react';
import { 
  Container, 
  Typography, 
  Box
} from '@mui/material';
import MetricsDashboard from './dashboard/MetricsDashboard';

const Dashboard = () => {

  return (
    <Container maxWidth="xl" sx={{ mt: 4, bgcolor: 'background.default', py: 3 }}>
      
      {/* Metrics Dashboard Cards */}
      <MetricsDashboard />
    </Container>
  );
};

export default Dashboard;